import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  profile: null,
  updatePasswordRes: null,
  uploadProfileRes: null,
  profileImage: null,
  uploadProfileImageRes: null,
  headerCounts: null,
  otherUsersProfileImage: {},
  error: null,
  loading: false,
};

// getProfile
const getProfileStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true, profile: null });
};

const getProfileSuccess = (state: any, action: any) => {
  return updateObject(state, {
    profile: action.profile,
    error: null,
    loading: false,
  });
};

const getProfileFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    profile: null,
  });
};

// getProfileImage
const getProfileImageStart = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: true,
    profileImage: null,
  });
};

const getProfileImageSuccess = (state: any, action: any) => {
  return updateObject(state, {
    profileImage: action.profileImage,
    error: null,
    loading: false,
  });
};

const getProfileImageFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// updateProfileImage
const uploadProfileImageStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const uploadProfileImageSuccess = (state: any, action: any) => {
  return updateObject(state, {
    uploadProfileImageRes: action.uploadProfileImageRes,
    error: null,
    loading: false,
  });
};

const uploadProfileImageFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const countForHeaderStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const countForHeaderSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
    headerCounts: action.countData,
  });
};

const countForHeaderFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Update profile Data
const updateProfileStart = (state:any) => {
  return updateObject(state, { error: null, loading: true });
}

const updateProfileSuccess = (state: any, action: any) => {
  return updateObject(state, {
    profile: {...state.profile,...action.updatedProfile},
    error: null,
    loading: false,
  });
}

const updateProfileFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
}

// switch user type
const switchUserTypeStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true, });
};

const switchUserTypeSuccess = (state: any, action: any) => {
  return updateObject(state, {
    profile: {...state.profile, type: action.profileType} ,
    error: null,
    loading: false,
  });
};

const switchUserTypeFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Delete account
const deleteAccountStart = (state: any) => {
  return updateObject(state, { error: null, loading: true, });
};

const deleteAccountSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
    profile: null,
    profileImage: null,
  });
};

const deleteAccountFail = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Toggle push notifications
const togglePushNotificationsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true, });
};

const togglePushNotificationsSuccess = (state: any) => {
  return updateObject(state, { error: null, loading: false, });
};

const togglePushNotificationsFail = (state: any, action: any) => {
  return updateObject(state, { error: action.error, loading: false, });
};

// Get other users profile Image
const getOtherUsersProfileImageStart = (state: any, action: any) => {
  return updateObject(state, {
    otherUsersProfileImage: {...state.otherUsersProfileImage, [action.data.msisdn]: ""},
  });
};

const getOtherUsersProfileImageSuccess = (state: any, action: any) => {
  return updateObject(state, {
    otherUsersProfileImage: {...state.otherUsersProfileImage,  [action.data.msisdn]: action.data.data},
  });
};

const getOtherUsersProfileImageFailed = (state: any, action: any) => {
  return updateObject(state, {
    otherUsersProfileImage: {...state.otherUsersProfileImage, [action.data.msisdn]: ""},
  });
};

const profileReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // case actionTypes.PROFILE_UPDATE_PASSWORD_START:
    //     return updatePasswordStart(state, action);
    // case actionTypes.PROFILE_UPDATE_PASSWORD_SUCCESS:
    //     return updatePasswordSuccess(state, action);
    // case actionTypes.PROFILE_UPDATE_PASSWORD_FAIL:
    //     return updatePasswordFail(state, action);
    case actionTypes.GET_USER_PROFILE_START:
      return getProfileStart(state, action);
    case actionTypes.GET_USER_PROFILE_SUCCESS:
      return getProfileSuccess(state, action);
    case actionTypes.GET_USER_PROFILE_FAIL:
      return getProfileFail(state, action);
    case actionTypes.GET_PROFILE_IMAGE_START:
      return getProfileImageStart(state, action);
    case actionTypes.GET_PROFILE_IMAGE_SUCCESS:
      return getProfileImageSuccess(state, action);
    case actionTypes.GET_PROFILE_IMAGE_FAIL:
      return getProfileImageFail(state, action);
    case actionTypes.UPLOAD_PROFILE_IMAGE_START:
      return uploadProfileImageStart(state, action);
    case actionTypes.UPLOAD_PROFILE_IMAGE_SUCCESS:
      return uploadProfileImageSuccess(state, action);
    case actionTypes.UPLOAD_PROFILE_IMAGE_FAIL:
      return uploadProfileImageFail(state, action);
    case actionTypes.HEADER_COUNT_START:
      return countForHeaderStart(state);
    case actionTypes.HEADER_COUNT_SUCCESS:
      return countForHeaderSuccess(state, action);
    case actionTypes.HEADER_COUNT_FAIL:
      return countForHeaderFailed(state, action);
    case actionTypes.UPDATE_PROFILE_DATA_START:
      return updateProfileStart(state);
    case actionTypes.UPDATE_PROFILE_DATA_SUCCESS:
      return updateProfileSuccess(state, action);
    case actionTypes.UPDATE_PROFILE_DATA_FAIL:
      return updateProfileFailed(state, action);
    case actionTypes.SWITCH_USER_TYPE_START:
      return switchUserTypeStart(state, action);
    case actionTypes.SWITCH_USER_TYPE_SUCCESS:
      return switchUserTypeSuccess(state, action);
    case actionTypes.SWITCH_USER_TYPE_FAIL:
      return switchUserTypeFail(state, action);
    case actionTypes.DELETE_ACCOUNT_START:
      return deleteAccountStart(state);
    case actionTypes.DELETE_ACCOUNT_SUCCESS:
      return deleteAccountSuccess(state);
    case actionTypes.DELETE_CONVERSATIONS_FAIL:
      return deleteAccountFail(state, action);

    // Toggle push notifications
    case actionTypes.TOGGLE_PUSH_NOTIFICATIONS_START:
      return togglePushNotificationsStart(state);
    case actionTypes.TOGGLE_PUSH_NOTIFICATIONS_SUCCESS:
      return togglePushNotificationsSuccess(state);
    case actionTypes.TOGGLE_PUSH_NOTIFICATIONS_FAIL:
      return togglePushNotificationsFail(state, action);

    // Get other users profile Image
    case actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_START:
      return getOtherUsersProfileImageStart(state, action);
    case actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_SUCCESS:
      return getOtherUsersProfileImageSuccess(state, action);
    case actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_FAIL:
      return getOtherUsersProfileImageFailed(state, action);

    default:
      return state;
  }
};

export default profileReducer;
